export enum MembershipState {
  New = 'ny kunde',
  Existing = 'eksisterende kunde',
  Unknown = 'ukendt kundetilknytning',
}
